export default "__VITE_ASSET__BGm$6pMR__"